import {useState} from "react"
import {apiExpertSuggestions} from "./Api"
import {progressBar} from "../settings"

const STEP_IMPRESSIONS = "impressions"
const STEP_SUGGESTION = "suggestion"

export const pager = () => {
    const getPage = () => {
        return sessionStorage.getItem('suggestedSolutionsPage') ? parseInt(sessionStorage.getItem('suggestedSolutionsPage')) : 1
    }

    const incrementPage = () => {
        sessionStorage.setItem('suggestedSolutionsPage', (getPage() + 1).toString())
    }

    const resetPage = () => {
        sessionStorage.setItem('suggestedSolutionsPage', '1')
    }
    return {getPage, incrementPage, resetPage}
}

export const useSuggestedSolutions = () => {
    const [state, setState] = useState({
        load: true,
        error: null,
        expertSuggestions: null,
        step: STEP_IMPRESSIONS,
    })

    const load = async (roomId, lang) => {
        if (roomId && lang) {
            try {
                const result = await Promise.all([apiExpertSuggestions(roomId, lang), sleep(progressBar.minimumProcessingTime)]);
                const [data] = result
                setState(prevState => ({...prevState, load: false, expertSuggestions: data.expertSuggestions}))
            } catch (error) {
                setState(prevState => ({...prevState, load: false, error}))
            }
        }

        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
    }

    const loadRaw = async (roomId, lang) => {
        if (roomId && lang) {
            try {
                const result = await apiExpertSuggestions(roomId, lang)
                return getSolutionsPage(result.expertSuggestions)
            } catch (error) {

            }
        }
        return []
    }

    const reset = () => {
        setState(prevState => ({...prevState, load: true, error: null, expertSuggestions: null}))
    }

    const isStepImpressions = () => {
        return state.step === STEP_IMPRESSIONS
    }

    const isStepLoading = () => {
        return state.step === STEP_SUGGESTION
    }

    const setStep = (step) => {
        setState(prevState => ({...prevState, step}))
    }

    const stepNext = () => {
        if (isStepImpressions()) setStep(STEP_SUGGESTION)
    }

    const stepBack = () => {
        if (isStepLoading()) setStep(STEP_IMPRESSIONS)
    }

    const isLoading = () => {
        return !!state?.load
    }

    const hasError = () => {
        return !!state?.error
    }

    const getError = () => {
        return state?.error?.title
    }

    const hasSolutions = () => {
        return (state?.expertSuggestions ?? []).length > 0
    }

    const getSolutions = () => {
        return getSolutionsPage(state?.expertSuggestions ?? [])
    }

    const getSolutionsPage = (expertSuggestions, pageSize = 3) => {

        if (expertSuggestions.length === 0) {
            return []
        }

        const start = (pager().getPage() - 1) * pageSize
        const end = pager().getPage() * pageSize
        pager().incrementPage()

        if (start > expertSuggestions.length) {
            pager().resetPage()
            return getSolutionsPage(expertSuggestions)
        }

        return expertSuggestions.slice(start, end)
    }

    return {
        isLoading, hasError, getError, load, loadRaw, reset,
        hasSolutions, getSolutions, getSolutionsPage,
        isStepImpressions, isStepLoading,
        stepNext, stepBack,
    }
}
